/* eslint-disable @typescript-eslint/no-explicit-any */
import { getGridDateOperators, GridFilterOperator } from '@mui/x-data-grid';
import { DateTime } from 'luxon';
import DatesIntervalInput from './DatesIntervalInput';

const betweenDatesOperator: GridFilterOperator<any, Date | null, any>[] = [
  {
    label: 'is between',
    value: 'between',
    getApplyFilterFn: (filterItem, _columns) => {
      if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
        return null;
      }
      if (filterItem.value[0] == null || filterItem.value[1] == null) {
        return null;
      }
      return (value) => {
        return (
          value !== null &&
          DateTime.fromJSDate(value) >= filterItem.value[0] &&
          DateTime.fromJSDate(value) <= filterItem.value[1]
        );
      };
    },

    InputComponent: DatesIntervalInput,
    InputComponentProps: {
      sx: {
        width: 300,
      },
    },
  },
];

export const DateFilterOperators = [
  ...getGridDateOperators(),
  ...betweenDatesOperator,
];
